import iconVaccine from "assets/images/auth/icons/icon-vaccine.svg";
import iconCar from "assets/images/auth/icons/icon-car.svg";
import iconComplaint from "assets/images/auth/icons/icon-complaint.svg";

export const optionsNavMain = [
  // { to: "/vacunas", text: "Registrate para la vacuna", icon: iconVaccine },
  { to: "/", text: "Registrate para la vacuna", icon: iconVaccine },
  { to: "/vehiculos", text: "Mis vehículos", icon: iconCar },
  { to: "/tipo-denuncia", text: "Denunciar un robo", icon: iconComplaint },
];

export const optionsReports = [
  { to: "/seleccionar-vehiculo", text: "Mis vehículos", icon: iconCar },
  { to: "/", text: "", icon: iconVaccine },
  {
    to: "/denunciar",
    text: "Denunciar un robo de alguien más",
    icon: iconComplaint,
  },
];
